import { Box } from '@mui/material';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import CAppTitle from '../../../app/components/CAppTitle';
import LAppPublic from '../../../app/layouts/LAppPublic';
import VFaqArticleList from '../views/VFaqArticleList';
import useFaqArticlesPublic from '../hooks/useFaqArticlesPublic';
import langFaq from '../langs/langFaq';

const PFaqPublic = () => {
	const faqArticles = useFaqArticlesPublic();
	const { t } = useTranslation();
	return (
		<LAppPublic>
			<Helmet>
				<title>
					{t(langFaq.title.tag)} - {t(langFaq.subtitle.tag)}
				</title>
			</Helmet>
			<CAppTitle title={t(langFaq.title.tag)} subtitle={t(langFaq.subtitle.tag)} />
			<Box sx={{ paddingBottom: '50px' }}>
				<VFaqArticleList articles={faqArticles} />
			</Box>
		</LAppPublic>
	);
};

export default PFaqPublic;
